<template>
  <div class="charge-mgmt">
    <div class="main-title">
      <p v-if="view==='list'" @click="cancelHandle">{{ $t('lang.Vehicle Management') }}</p>
      <p v-if="view==='detail' || view==='detailOther'" @click="cancelHandle">{{ $t('lang.Vehicle Management') }}</p>
      <p v-if="view==='detail' || view==='detailOther'">>{{ $t('lang.Details') }}</p>
      <p v-if="view==='edit'" @click="cancelHandle">{{ $t('lang.Vehicle Management') }}</p>
      <p v-if="view==='edit'">>{{ $t('lang.Edit') }}</p>
      <p v-if="view==='operationLog'" @click="cancelHandle">{{ $t('lang.Vehicle Management') }}</p>
      <p v-if="view==='operationLog'">>{{ $t('lang.Operation Record') }}</p>
    </div>
    <div class="main-body" v-if="view=='list'">
      <el-form
        :inline="true"
        :model="form"
        class="demo-form-inline"
      >
        <el-form-item :label="$t('lang.Equipment Number')">
          <el-input v-model="form.searchCondition" :placeholder="$t('lang.Please enter the equipment number')"
                    clearable maxlength="50"/>
        </el-form-item>
        <el-form-item :label="$t('lang.ECU Manufacturer')">
          <el-select
            clearable
            class="fixed-width-100"
            v-model="form.controllerManufacturerNo">
            <el-option
              v-for="(item,key) in manufacturersList"
              :key="item.number"
              :label="item.name"
              :value="item.number">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.Agent/Store')">
          <query-unit-tree @change="unitChange"/>
        </el-form-item>
        <el-form-item :label="$t('lang.Linked Account')">
          <el-input v-model="form.userId" :placeholder="$t('lang.Please enter the Linked Account')" clearable
                    maxlength="50"/>
        </el-form-item>
        <el-form-item :label="$t('lang.Equipment State')">
          <el-select v-model="form.deviceStatus" placeholder="" clearable>
            <el-option
              v-for="item in deviceStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.Import Time')">
          <el-date-picker
            v-model="timeArr"
            type="datetimerange"
            range-separator="-"
            value-format="timestamp"
            :start-placeholder="$t('lang.start time')"
            :end-placeholder="$t('lang.end time')">
          </el-date-picker>
        </el-form-item>
        <el-button type="primary" @click="handleCurrentChange()">{{ $t('lang.Inquire') }}</el-button>
        <el-button type="primary" @click="activeBtnClick">{{ $t('lang.Activate') }}</el-button>
        <el-button type="primary" @click="confirmDownloadBtnClick">{{ $t('lang.Export') }}</el-button>
      </el-form>
      <el-table
        @selection-change="selectChange"
        :data="dataList"
        style="width: 100%;margin-bottom: 20px;"
        class="table-custom"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="number" :label="$t('lang.Equipment Number')" width="200"></el-table-column>
        <el-table-column prop="udid" :label="$t('lang.ECU Number')" width="250"></el-table-column>
        <el-table-column prop="controllerManufacturer" :label="$t('lang.ECU Manufacturer')" width="200"></el-table-column>
        <el-table-column prop="specification" :label="$t('lang.Vehicle Spec')" width="200"></el-table-column>
        <el-table-column prop="frameNo" :label="$t('lang.Vehicle Frame Number')" width="200"></el-table-column>
        <el-table-column prop="vinNo" :label="$t('lang.License Plates')" width="200"></el-table-column>
        <!--<el-table-column prop="deviceName" :label="$t('lang.Agent/Store')" width="200"></el-table-column>-->
        <el-table-column prop="targetNumber" :label="$t('lang.Linked Account')" width="200"></el-table-column>
        <el-table-column prop="deviceStatus" :label="$t('lang.Online State')" width="200"></el-table-column>
        <el-table-column prop="status" :label="$t('lang.Equipment State')" width="200">
          <template slot-scope="{row}">
            <div>{{getDeviceStatus(row)}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('lang.Import Time')" width="200"></el-table-column>
        <el-table-column width="200" fixed="right">
          <template slot-scope="{row}">
            <div>
              <el-button type="primary" size="mini" @click="onEditBtnClick(row)">{{ $t('lang.Edit') }}</el-button>
              <el-button type="primary" size="mini" @click="onDetailBtnClick(row)">{{ $t('lang.Details') }}</el-button>
            </div>
            <div>
              <el-button type="primary" style="margin-top: 10px;" size="mini" @click="bindBtnClick(row)">{{ $t('lang.Linked Account') }}</el-button>
            </div>
            <div>
              <el-button type="primary" style="margin-top: 10px;" size="mini"  @click="onOperationLogBtnClick(row)">{{ $t('lang.Operation Record') }}</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="dfcc">
        <el-pagination
          :current-page="form.beginIndex + 1"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10,20, 30, 40,50]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <div class="main-body" v-if="view == 'edit'">
      <electric-bicycle-mgmt-edit-view
        :editData="editData"
        :deviceStatusList="deviceStatusList"
        @editSuccess=""
        @cancel="cancelHandle"
      ></electric-bicycle-mgmt-edit-view>
    </div>
    <div class="main-body" v-if="view == 'detail'">
      <electric-bicycle-mgmt-detail-view
        :editData="editData"
        :deviceStatusList="deviceStatusList"
        @cancel="cancelHandle"
      ></electric-bicycle-mgmt-detail-view>
    </div>
    <div class="main-body" v-if="view == 'detailOther'">
      <electric-bicycle-mgmt-detail-view-other
        :editData="editData"
        @cancel="cancelHandle">
      </electric-bicycle-mgmt-detail-view-other>
    </div>
    <div class="main-body" v-if="view == 'operationLog'">
      <electric-bicycle-operation-log :editData="editData"></electric-bicycle-operation-log>
    </div>
    <el-dialog :title="$t('lang.Linked Account')" :visible.sync="bindVisible" width="30%">
      <div class="bind-input-box">
        <div>{{$t('lang.Account Number')}}:</div>
        <el-input
          class="class-input"
          v-model="bindItem.userId"
          :placeholder="$t('lang.Please enter the user ID')"
          clearable
          :disabled="bindItem.bindFlag"
          maxlength="50"/>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="unbindBtnClick" v-if="bindItem.bindFlag" plain>{{ $t('Unbind') }}</el-button>
        <el-button type="primary" @click="confirmBind">{{$t('Confirm')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ElectricBicycleMgmtEditView from './electricBicycleEditView';
import ElectricBicycleMgmtAddView from './electricBicycleAddView';
import ElectricBicycleMgmtDetailView from './electricBicycleDetailView';
import queryUnitTree from '@/components/common/queryUnitTree';
import {
  activateElectricBicycle, bindBicycleBelongUser,
  cleanThailandBicycleBelongUser, queryDeviceManufacturerInfo,
  queryThailandElectricBicycleList
} from '../../api/deviceManagement';
import {exportExcel} from '../../api/export';
import ElectricBicycleMgmtDetailViewOther from './electricBicycleDetailViewOther';
import ElectricBicycleOperationLog from './electricBicycleOperationLog';

export default {
  name: 'electricBicycleMgmt',
  components: {
    ElectricBicycleOperationLog,
    ElectricBicycleMgmtDetailViewOther,
    ElectricBicycleMgmtDetailView,
    ElectricBicycleMgmtAddView,
    ElectricBicycleMgmtEditView,
    queryUnitTree
  },
  data() {
    return {
      //查询的表单
      form: {
        searchCondition: '',
        deviceType: '6',
        vinNo: '',
        controllerManufacturerNo: '',
        unitNo: '',
        userId: '',
        deviceStatus: '',
      },
      //中控厂商列表
      manufacturersList: [],
      //时间
      timeArr: [],
      //分页信息
      pageInfo: {
        beginIndex: 0,
        pageSize: 10,
      },
      //数据
      dataList: [],
      total: 0,
      //设备状态
      deviceStatusList: [
        {
          label: this.$t('Wait to post'),
          value: 1
        },
        {
          label: this.$t('Posted'),
          value: 2
        },
        {
          label: this.$t('Unactivated'),
          value: 3
        },
        {
          label: this.$t('Activated'),
          value: 4
        }
      ],
      selectList: [],
      //编辑信息
      editData: {},
      // 绑定的电动车信息
      bindItem: {},
      view: 'list',
      // 是否正在激活的标志
      isActiveLoadingFlag: false,
      // 是否正在导出的标志
      isExportLoadingFlag: false,
      //是否显示绑定弹窗的标志
      bindVisible: false,
      isUnbindLoadingFlag: false,
      isBindLoadingFlag: false
    }
  },
  mounted() {
    this.$set(this.timeArr, 0, this.$m().set({
      'hour': 0,
      'minute': 0,
      'seconds': 0
    }).valueOf())
    this.$set(this.timeArr, 1, this.$m().set({
      'hour': 23,
      'minute': 59,
      'seconds': 59
    }).valueOf())
    this.handleCurrentChange()
    this.queryDeviceManufacturerInfo()
  },
  methods: {
    /**
     * 获取厂商列表
     * @return {Promise<void>}
     */
    async queryDeviceManufacturerInfo() {
      const params = {
        deviceType: '7'
      }
      const res = await queryDeviceManufacturerInfo(params)
      this.manufacturersList = res.ldata
    },
    /**
     * 进入电动车的操作记录页面
     */
    onOperationLogBtnClick(item) {
      this.view = 'operationLog';
      this.$nextTick(() => {
        this.editData = item;
      });
    },
    getDeviceStatus(item) {
      const statusItem = this.deviceStatusList.find((el) => {
        return el.value == item.statusCode
      })
      if(statusItem) {
        return statusItem.label
      }
      return ''
    },
    /**
     * 进行绑定
     */
    async confirmBind() {
      if(this.isBindLoadingFlag) {
        this.$message.warning(this.$t('lang.In operation') + '...')
        return
      }
      //需要先解绑
      if(this.bindItem.bindFlag) {
        this.$message.warning(this.$t('lang.Please unbind first'))
        return
      }
      const params = {
        deviceNo: this.bindItem.number,
        userId: this.bindItem.userId
      }
      try {
        this.isBindLoadingFlag = true
        await bindBicycleBelongUser(params)
        this.isBindLoadingFlag = false
        this.bindVisible = false
        this.queryThailandElectricBicycleList()
        this.$message.success(this.$t('lang.Successful'))
      } catch (e) {
        this.isBindLoadingFlag = false
      }
    },
    /**
     * 解绑按钮点击
     */
    unbindBtnClick() {
      let self = this;
      this.$confirm(this.$t('lang.Are you sure to unbind the account ID?'), "", {
        confirmButtonText: this.$t('lang.Confirm'),
        cancelButtonText: this.$t('lang.Cancel'),
        type: "warning"
      }).then(() => {
        self.toUnbind();
      }).catch(action => {

      });
    },
    /**
     * 进行解绑
     */
    async toUnbind() {
      if(this.isUnbindLoadingFlag) {
        this.$message.warning(this.$t('In operation') + '...')
        return
      }
      const params = {
        number: this.bindItem.number
      }
      try {
        this.isUnbindLoadingFlag = true
        await cleanThailandBicycleBelongUser(params)
        this.isUnbindLoadingFlag = false
        this.$message.success(this.$t('Successful'))
        this.bindVisible = false
        this.bindItem.bindFlag = false
        this.bindItem.userId = ''
        this.queryThailandElectricBicycleList()
      } catch (e) {
        this.isUnbindLoadingFlag = false
      }
    },
    /**
     * 点击绑定按钮
     */
    bindBtnClick(item) {
      //未激活
      if(item.statusCode === 3) {
        this.$message.error(this.$t('The vehicle is not activated and cannot perform operation'))
        return
      }
      if(item.userId) {
        item.bindFlag = true
      }
      this.bindItem = JSON.parse(JSON.stringify(item))
      this.bindVisible = true
    },
    /**
     * 点击导出按钮
     */
    confirmDownloadBtnClick() {
      let self = this;
      this.$confirm(this.$t('lang.Whether to confirm export'), "", {
        confirmButtonText: this.$t('lang.Confirm'),
        cancelButtonText: this.$t('lang.Cancel'),
        type: "warning"
      }).then(() => {
        self.toExport();
      }).catch(action => {

      });
    },
    /**
     * 进行导出
     */
    async toExport() {
      const self = this
      if(this.isExportLoadingFlag) {
        this.$message.warning(this.$t('In operation') + '...')
        return
      }
      const params = {
        udid: this.form.searchCondition,
        vinNo: this.form.vinNo,
        userId: this.form.userId,
        bicycleStatus: this.form.deviceStatus,
        deviceType: '6',
        exportType: 35,
        unitNo: this.form.unitNo,
      }
      if (this.timeArr && this.timeArr.length > 0) {
        params.beginTime = this.$changeTime.sendTime(this.timeArr[0], 'x');
        params.endTime = this.$changeTime.sendTime(this.timeArr[1], 'x');
      } else {
        params.beginTime = null;
        params.endTime = null;
      }
      try {
        this.isExportLoadingFlag = true
        await exportExcel(params)
        this.isExportLoadingFlag = false
        this.$message.success(this.$t('lang.Export successful'))
        setTimeout(function () {
          self.$router.push('/managePage/downloadTask')
        }, 1000)
      } catch (e) {
        this.isExportLoadingFlag = false
      }
    },
    /**
     * 点击批量激活按钮
     */
    activeBtnClick() {
      const self = this;
      if(!this.selectList.length) {
        this.$message.warning(this.$t('Please select the device to be activated first'))
        return
      }
      this.$confirm(this.$t('Whether to activate the selected device'), "", {
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('Cancel'),
        type: "warning"
      }).then(()=>{
        self.toActive();
      })
    },
    /**
     * 进行激活
     * @returns {Promise<void>}
     */
    async toActive() {
      if(this.isActiveLoadingFlag) {
        this.$message.warning(this.$t('In operation') + '...')
        return
      }
      const params = {
        //转成逗号拼接字符串
        udidList: this.selectList.map((el) => {
          return el.udid
        }).join()
      }
      try {
        this.isActiveLoadingFlag = true
        await activateElectricBicycle(params)
        this.isActiveLoadingFlag = false
        this.$message.success(this.$t('Successful'))
        this.queryThailandElectricBicycleList()
      } catch (e) {
        this.isActiveLoadingFlag = false
      }
    },
    /**
     * 编辑
     * @param item
     */
    onEditBtnClick(item) {
      //未激活和已投放无法进行编辑
      if([2, 3].includes(Number(item.statusCode)) ) {
        this.$message.warning(this.$t('lang.The current state does not allow operations'))
        return
      }
      this.view = "edit";
      this.$nextTick(() => {
        this.editData = item;
      });
    },
    /**
     * 详情
     * @param item
     */
    onDetailBtnClick(item) {
      //未激活
      if(item.statusCode === 3) {
        this.$message.error(this.$t('The vehicle is not activated and cannot perform operation'))
        return
      }
      if(item.centralControllerTypeCode == 1) {
        this.view = 'detail';
      } else {
        this.view = 'detailOther';
      }
      this.$nextTick(() => {
        this.editData = item;
      });
    },
    /**
     * 退回列表页
     */
    cancelHandle() {
      this.view = "list";
      this.queryThailandElectricBicycleList();
    },
    /**
     * 选中改变
     */
    selectChange(val) {
      console.log(val)
      this.selectList = val
    },
    /**
     * 组织改变
     */
    unitChange(val) {
      console.log(val)
      if(val && val.length) {
        this.form.unitNo = val[val.length - 1]
      }
    },
    /**
     * 获取电动车列表
     */
    async queryThailandElectricBicycleList() {
      const params = {
        ...this.form,
        ...this.pageInfo
      }
      if (this.timeArr && this.timeArr.length > 0) {
        params.beginTime = this.$changeTime.sendTime(this.timeArr[0], 'x');
        params.endTime = this.$changeTime.sendTime(this.timeArr[1], 'x');
      } else {
        params.beginTime = null;
        params.endTime = null;
      }
      const res = await queryThailandElectricBicycleList(params)
      this.dataList = res.ldata;
      this.total = res.mdata.total;
    },
    /**
     * 个数改变
     * @param pageSize
     */
    handleSizeChange(pageSize) {
      this.form.pageSize = pageSize;
      this.queryThailandElectricBicycleList();
    },
    /**
     * 页面跳转
     * @param page
     */
    handleCurrentChange(page = 1) {
      this.form.beginIndex = page - 1;
      this.queryThailandElectricBicycleList();
    },
  },
}
</script>

<style lang="scss" scoped>
.main-body {
  .list {
    line-height: 30px;
    margin: 20px 30px 10px;

    .name-label {
      float: left;
    }

    .value-label {
      display: inline-block;
      height: 30px;
    }

    .date-global {
      width: 185px;
    }

    .list-input {
      width: 180px;
    }
  }

  .table-custom {
    .text-btn {
      width: 50px;
      height: 24px;
      line-height: 24px;
      color: #417505;
      display: inline-block;
      background-color: #bee6b3;
      cursor: pointer;
    }

    .fixed-width-75 {
      width: 75px;
    }
  }
}
.bind-input-box {
  display: flex;
  align-items: center;
  .class-input {
    width: 200px;
    margin-left: 10px;
  }
  .class-button {
    margin-left: 30px;
    color: #4CB132;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/electricBicycleMgmt.vue